import React from "react";
import { resolvePath } from "../utils/resolvePath";


export const Layout: React.FC<{
    copyright: string;
    footerLink?: string;
    footerLinkTitle?: string;
    children?: React.ReactNode;
}> = ({ copyright, footerLink, footerLinkTitle, children }) => {
    return (
      <div className='page'>
        <header className='header'>
          <div className='header__inner'>
            <a className='logo' href='/'>
              <img src={resolvePath('logo.png')} className='logo__img' alt='Prisma Cloud' />
            </a>
          </div>
        </header>
        <main className="main">{children}</main>
        <footer className='footer'>
          <div className='footer__inner'>
            <div className='footer__copy'>{copyright}</div>

            {footerLink && (
              <div className='footer__links'>
                <a className='footer__link' target='_blank' href={footerLink}>
                  {footerLinkTitle}
                </a>
              </div>
            )}
          </div>
        </footer>
      </div>
    );
};
